/**
 * @fileoverview PUT handler for the "/comments/:target/threads/:thread_id/reopen" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { mutationCacheKeys } from "./constants";
import type { AppendAppGroupToUrl, ReopenCommentThreadProps, ReopenCommentThreadResult } from "./types";

export const reopenCommentThread = reactQueryMutationAdapter(
  mutationCacheKeys,
  (props: AppendAppGroupToUrl<ReopenCommentThreadProps>): Promise<ReopenCommentThreadResult> => {
    return fetch(
      `/comments/${props.target}/threads/${props.threadId}/reopen?app_group_id=${props.appGroupId}`,
      "PUT"
    );
  }
);
